<template>
	<Page>
		<Section>
			<SectionLine class="line" @click="setColdPassword">
				<div><KeyIcon class="icon" />Set password</div>
				<ChevronRightIcon class="icon" />
			</SectionLine>

			<SectionLine class="line" @click="viewSeedPhrase">
				<div><FileSearchAltIcon class="icon" />View seed phrase</div>
				<ChevronRightIcon class="icon" />
			</SectionLine>

			<SectionLine class="line destructive" @click="removeCurrentWalletCold">
				<div><TrashIcon class="icon" />Remove wallet</div>
				<ChevronRightIcon class="icon" />
			</SectionLine>
		</Section>

		<Section>
			<SectionLine v-if="!walletCloudStore.isEmpty" class="line" @click="setCloudPassword">
				<div><KeyIcon class="icon" />Set cloud password</div>
				<ChevronRightIcon class="icon" />
			</SectionLine>

			<SectionLine class="line" @click="switchSyncWallet">
				<div><CloudIcon class="icon" />Sync wallet</div>
				<BaseSwitch :value="isSyncCurrentWallet" />
			</SectionLine>

			<SectionLine v-if="!walletCloudStore.isEmpty" class="line destructive" @click="walletCloudStore.clear()">
				<div><CloudXmarkIcon class="icon" />Delete cloud</div>
				<ChevronRightIcon class="icon" />
			</SectionLine>
		</Section>

		<Section>
			<SectionLine class="line" @click="telegram.WebApp.openTelegramLink('https://t.me/Waves_Super_App')">
				<div><UsersIcon class="icon" />Support group</div>
				<ChevronRightIcon class="icon" />
			</SectionLine>
		</Section>
	</Page>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useWalletStore } from '@/stores/useWalletStore';
import { storeToRefs } from 'pinia';
import { useWalletCloudStore } from '@/stores/useWalletCloudStore';
import { useRouter } from 'vue-router';
import Section from '@/components/ui/Section.vue';
// import BaseSectionButton from '@/components/ui/SectionButton.vue';
import SectionLine from '@/components/ui/SectionLine.vue';
import BaseSwitch from '@/components/ui/BaseSwitch.vue';
import KeyIcon from '@/assets/icons/key-alt.svg?component';
import TrashIcon from '@/assets/icons/trash.svg?component';
import FileSearchAltIcon from '@/assets/icons/file-search-alt.svg?component';
import CloudIcon from '@/assets/icons/cloud.svg?component';
import CloudXmarkIcon from '@/assets/icons/cloud-xmark.svg?component';
import ChevronRightIcon from '@/assets/icons/chevron-right.svg?component';
import UsersIcon from '@/assets/icons/users.svg?component';
import { useModal } from '@/stores/useModalStore';
import SetPasswordModal from '@/components/modals/SetPasswordModal.vue';
import SetPasswordCloudStorageModal from '@/components/modals/SetPasswordCloudStorageModal.vue';
import Page from '@/components/ui/Page.vue';
import { useTelegram } from '@/composables/useTelegram';
import ViewSeedModal from '@/components/modals/ViewSeedModal.vue';

const walletStore = useWalletStore();
const walletCloudStore = useWalletCloudStore();
const router = useRouter();
const { telegram } = useTelegram();
const { cloudPublicKeys, publicKey, seed } = storeToRefs(walletStore);
// const commitHash = __COMMIT_HASH__;
// const version = __VERSION__;

const isSyncCurrentWallet = computed(() =>
	publicKey.value && cloudPublicKeys.value ? cloudPublicKeys.value.has(publicKey.value) : false
);

const removeCurrentWalletCold = () => {
	walletStore.removeWallet(seed.value.phrase);
	router.replace('/');
};

const viewSeedPhrase = () => {
	useModal({
		component: ViewSeedModal,
		isShow: true
	});
};

const switchSyncWallet = () => {
	if (isSyncCurrentWallet.value) {
		walletCloudStore.removeWallet(seed.value.phrase);
	} else {
		walletCloudStore.addWallet(seed.value.phrase);
	}
};

const setColdPassword = () => {
	useModal({
		component: SetPasswordModal,
		isShow: true
	});
};

const setCloudPassword = () => {
	walletCloudStore.decryptBefore(() => {
		useModal({
			component: SetPasswordCloudStorageModal,
			isShow: true
		});
	});
};
</script>

<style scoped>
.line {
	cursor: pointer;
}

.line > *:first-child {
	display: flex;
	align-items: center;
	gap: var(--size-s);
}

.earn-info-list {
	display: grid;

	gap: 8px;

	grid-template-columns: 1fr 1fr;
}

.icon {
	stroke: rgba(75, 86, 117, 1);
	vertical-align: middle;
}
</style>
